module.exports = __webpack_public_path__ + "media/images/samples/infographics/zoomed@2x-ad51b409044cc09f0844030b1258f45a.jpg";